import type {PageRouteConfig} from '@router';

import CouponPaymentSuccess from 'modules/Services/PromotionCenter/Coupon/PaymentSuccess/CouponPaymentSuccess';

export function createPromotionCenterCouponPaymentSuccessRoute(): PageRouteConfig {
  return {
    element: <CouponPaymentSuccess />,
    layout: {
      title: '',
      hasNavigate: false,
      hasHeader: false,
      hasBack: true,
      hasLeftIcon: false,
      link: -1
    }
  };
}
